import { render, staticRenderFns } from "./App.vue?vue&type=template&id=643b668e&scoped=true&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"
import style0 from "./style/global.styl?vue&type=style&index=0&lang=stylus&"
import style1 from "./App.vue?vue&type=style&index=1&id=643b668e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643b668e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/akryum/Projects/vue-devtools/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('643b668e')) {
      api.createRecord('643b668e', component.options)
    } else {
      api.reload('643b668e', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=643b668e&scoped=true&", function () {
      api.rerender('643b668e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@vue-devtools/app-frontend/src/App.vue"
export default component.exports